export default "__VITE_ASSET__bc4a4b3d__"